import { Platform } from 'react-native';
import { appTheme } from '../appTheme';
import {
  androidAppHeaderContentHeight,
  androidDashboardHeaderCollapsedHeight,
  androidDashboardHeaderExpandedHeight,
  androidDashboardHeaderScrollThreshold,
  androidScaleSize,
} from '../androidUiParity';
import { STACK_SCROLL_GUTTER } from '../studio/stackScreenShell';

export const SCREEN_HEADER_HEIGHT = 56;
export const SCREEN_HEADER_HEIGHT_COMPACT = 44;
export const SCREEN_HEADER_ICON_SIZE = 24;
export const INLINE_BACK_SIZE = 40;
export const HEADER_BACK_ICON_SIZE_INLINE = 22;
export const DEFAULT_HEADER_SCROLL_THRESHOLD = 80;
export const HEADER_HORIZONTAL_PADDING = STACK_SCROLL_GUTTER;

/** Width of stack header left/right action columns — keeps title optically centered. */
export const HEADER_SIDE_SLOT_WIDTH = 60;

export function resolveHeaderSideSlotWidth(): number {
  return Platform.OS === 'android' ? androidScaleSize(HEADER_SIDE_SLOT_WIDTH) : HEADER_SIDE_SLOT_WIDTH;
}

export const TAB_HEADER_EXPANDED_HEIGHT =
  Platform.OS === 'android' ? androidDashboardHeaderExpandedHeight() : 88;
/** Title-only tab screens (Calendar) — no subtitle / bottom slot. */
/** Title-only tab screens (Calendar) — shell height matches title + bottom padding; keep iOS/Android close. */
export const TAB_HEADER_EXPANDED_HEIGHT_COMPACT =
  Platform.OS === 'android'
    ? Math.max(androidDashboardHeaderCollapsedHeight(), androidScaleSize(44))
    : 48;
export const TAB_HEADER_COLLAPSED_HEIGHT =
  Platform.OS === 'android' ? androidDashboardHeaderCollapsedHeight() : 52;
export const TAB_HEADER_SCROLL_THRESHOLD =
  Platform.OS === 'android' ? androidDashboardHeaderScrollThreshold() : 100;

/** Scroll-linked header chrome: transparent at top → `surface` when collapsed. */
export const CHROME_REVEAL_SCROLL_THRESHOLD = TAB_HEADER_SCROLL_THRESHOLD;
export const CHROME_REVEAL_OPACITY_MAX = 1;
export const CHROME_REVEAL_FADE_START_RATIO = 0.35;
export const CHROME_REVEAL_FADE_END_RATIO = 0.75;

export function resolveChromeRevealInputRange(
  threshold = CHROME_REVEAL_SCROLL_THRESHOLD,
): [number, number, number] {
  return [0, threshold * CHROME_REVEAL_FADE_START_RATIO, threshold * CHROME_REVEAL_FADE_END_RATIO];
}

export function resolveScreenHeaderContentHeight(compact = false): number {
  return androidAppHeaderContentHeight(compact);
}

/** Circular header control — outline (border only) vs elevated (surface fill). */
export type HeaderBackButtonAppearance = 'outline' | 'elevated';

export function resolveHeaderBackButtonShellStyle(
  colors: { surface: string; borderSubtle: string },
  appearance: HeaderBackButtonAppearance,
) {
  return {
    backgroundColor: appearance === 'elevated' ? colors.surface : 'transparent',
    borderColor: colors.borderSubtle,
  };
}

export const FOOTER_CTA_HEIGHT_MAIN = 56;
export const FOOTER_CTA_HEIGHT_COMPACT = 52;

/** Classic menu header date block height (Android/iOS). */
export const MENU_HEADER_DATE_BLOCK_HEIGHT = Platform.OS === 'android' ? 125 : 160;
